/*
 * ============================================================
 * CUSTOM MINI CART
 *
 * File:
 * assets/custom-mini-cart.js
 *
 * IMPORTANT:
 * Load this AFTER custom-collection.js
 *
 * This does NOT replace your existing .quick-add AJAX.
 * ============================================================
 */

(function () {

  "use strict";


  /* ==========================================================
     MONEY
     ========================================================== */

  function money(cents) {

    var amount =
      Number(cents || 0) / 100;

    var currency =
      window.Shopify &&
      Shopify.currency &&
      Shopify.currency.active
        ? Shopify.currency.active
        : "INR";


    try {

      return new Intl.NumberFormat(
        "en-IN",
        {
          style: "currency",
          currency: currency,
          maximumFractionDigits: 2
        }
      ).format(amount);

    } catch (e) {

      return (
        currency +
        " " +
        amount.toFixed(2)
      );

    }

  }


  /* ==========================================================
     ESCAPE HTML
     ========================================================== */

  function esc(value) {

    var el =
      document.createElement("div");

    el.textContent =
      value == null
        ? ""
        : String(value);

    return el.innerHTML;

  }


  /* ==========================================================
     OPEN MINI CART
     ========================================================== */

  function openMiniCart() {

    var drawer =
      document.getElementById(
        "CustomMiniCart"
      );


    if (!drawer) {

      console.warn(
        "CustomMiniCart not found."
      );

      return;

    }


    if (
      typeof bootstrap === "undefined" ||
      !bootstrap.Offcanvas
    ) {

      console.error(
        "Bootstrap Offcanvas is not loaded."
      );

      return;

    }


    var instance =
      bootstrap.Offcanvas.getOrCreateInstance(
        drawer,
        {
          backdrop: true,
          keyboard: true,
          scroll: false
        }
      );


    instance.show();

  }


  /* ==========================================================
     REMOVE OLD QUANTITY HANDLERS
     ========================================================== */

  function removeOldHandlers() {

    document
      .querySelectorAll(
        "#CustomMiniCart .qty-plus, " +
        "#CustomMiniCart .qty-minus, " +
        "#CustomMiniCart .remove-item"
      )
      .forEach(
        function (button) {

          button.onclick = null;

        }
      );

  }


  /* ==========================================================
     RENDER CART
     ========================================================== */

  function render(cart) {

    var items =
      document.getElementById(
        "CustomMiniCartItems"
      );

    var count =
      document.getElementById(
        "CustomMiniCartCount"
      );

    var subtotal =
      document.getElementById(
        "CustomMiniCartSubtotal"
      );

    var empty =
      document.getElementById(
        "CustomMiniCartEmpty"
      );

    var content =
      document.getElementById(
        "CustomMiniCartContent"
      );

    var footer =
      document.getElementById(
        "CustomMiniCartFooter"
      );


    if (!items) {

      return;

    }


    if (count) {

      count.textContent =
        cart.item_count;

    }


    if (subtotal) {

      subtotal.textContent =
        money(cart.total_price);

    }


    /* EMPTY */

    if (
      cart.item_count === 0
    ) {

      items.innerHTML = "";


      if (empty) {

        empty.hidden = false;

      }


      if (content) {

        content.hidden = true;

      }


      if (footer) {

        footer.hidden = true;

      }


      return;

    }


    /* HAS ITEMS */

    if (empty) {

      empty.hidden = true;

    }


    if (content) {

      content.hidden = false;

    }


    if (footer) {

      footer.hidden = false;

    }


    items.innerHTML =
      cart.items
        .map(
          function (item) {

            var image =
              item.image
                ? (
                  '<img src="' +
                  item.image +
                  '" alt="' +
                  esc(
                    item.product_title
                  ) +
                  '" loading="lazy">'
                )
                : "";


            var variant =
              item.variant_title &&
              item.variant_title !==
                "Default Title"

                ? (
                  '<small class="text-muted d-block">' +
                  esc(
                    item.variant_title
                  ) +
                  "</small>"
                )

                : "";


            return (

              '<div class="custom-mini-cart-item" ' +
              'data-key="' +
              esc(item.key) +
              '">' +


                '<a href="' +
                item.url +
                '" class="custom-mini-cart-image">' +

                  image +

                "</a>" +


                '<div class="custom-mini-cart-info">' +


                  '<a href="' +
                  item.url +
                  '" class="custom-mini-cart-title">' +

                    esc(
                      item.product_title
                    ) +

                  "</a>" +


                  variant +


                  '<strong class="d-block mt-1">' +

                    money(
                      item.final_line_price
                    ) +

                  "</strong>" +


                  '<div class="custom-mini-cart-controls">' +


                    '<button type="button" ' +
                    'class="qty-minus" ' +
                    'data-key="' +
                    esc(item.key) +
                    '" ' +
                    'data-quantity="' +
                    item.quantity +
                    '">' +

                      "−" +

                    "</button>" +


                    "<span>" +

                      item.quantity +

                    "</span>" +


                    '<button type="button" ' +
                    'class="qty-plus" ' +
                    'data-key="' +
                    esc(item.key) +
                    '" ' +
                    'data-quantity="' +
                    item.quantity +
                    '">' +

                      "+" +

                    "</button>" +


                    '<button type="button" ' +
                    'class="remove-item" ' +
                    'data-key="' +
                    esc(item.key) +
                    '" ' +
                    'data-quantity="' +
                    item.quantity +
                    '">' +

                      "Remove" +

                    "</button>" +


                  "</div>" +


                "</div>" +


              "</div>"

            );

          }
        )
        .join("");


    removeOldHandlers();

  }


  /* ==========================================================
     UPDATE HEADER COUNT
     ========================================================== */

  function updateHeaderCount(cart) {

    document
      .querySelectorAll(
        ".cart-count, .header-cart-count"
      )
      .forEach(
        function (element) {

          element.textContent =
            cart.item_count;

        }
      );

  }


  /* ==========================================================
     REFRESH MINI CART
     ========================================================== */

  async function refresh(
    openAfter
  ) {

    try {

      var response =
        await fetch(
          "/cart.js",
          {
            headers: {
              Accept:
                "application/json"
            }
          }
        );


      if (!response.ok) {

        throw new Error(
          "Cart request failed."
        );

      }


      var cart =
        await response.json();


      updateHeaderCount(
        cart
      );


      render(cart);


      /*
       * Notify Shiprocket/Fastrr
       * and other integrations.
       */

      document.dispatchEvent(
        new CustomEvent(
          "cart:updated",
          {
            detail: {
              cart: cart
            }
          }
        )
      );


      document.dispatchEvent(
        new CustomEvent(
          "cart:drawer:updated",
          {
            detail: {
              cart: cart
            }
          }
        )
      );


      if (openAfter) {

        requestAnimationFrame(
          openMiniCart
        );

      }


    } catch (error) {

      console.error(
        "Mini cart refresh error:",
        error
      );

    }

  }


  /* ==========================================================
     QUANTITY / REMOVE
     ========================================================== */

  function bindQuantityEvents() {

    document.addEventListener(
      "click",
      async function (event) {

        var button =
          event.target.closest(
            "#CustomMiniCart .qty-plus, " +
            "#CustomMiniCart .qty-minus, " +
            "#CustomMiniCart .remove-item"
          );


        if (!button) {

          return;

        }


        event.preventDefault();


        var key =
          button.dataset.key;


        var current =
          Number(
            button.dataset.quantity ||
            0
          );


        var quantity =
          current;


        if (
          button.classList.contains(
            "qty-plus"
          )
        ) {

          quantity =
            current + 1;

        }


        if (
          button.classList.contains(
            "qty-minus"
          )
        ) {

          quantity =
            Math.max(
              0,
              current - 1
            );

        }


        if (
          button.classList.contains(
            "remove-item"
          )
        ) {

          quantity = 0;

        }


        button.disabled = true;


        try {

          var response =
            await fetch(
              "/cart/change.js",
              {
                method: "POST",

                headers: {
                  "Content-Type":
                    "application/json",

                  Accept:
                    "application/json"
                },

                body:
                  JSON.stringify(
                    {
                      id: key,
                      quantity:
                        quantity
                    }
                  )
              }
            );


          if (!response.ok) {

            throw new Error(
              "Unable to update cart."
            );

          }


          await refresh(
            false
          );


        } catch (error) {

          console.error(
            error
          );

        } finally {

          button.disabled =
            false;

        }

      }
    );

  }


  /* ==========================================================
     INSTALL
     ========================================================== */

  function install() {

    if (
      !window.ajaxCollection
    ) {

      return false;

    }


    /*
     * This is the important part.
     *
     * Your existing custom-collection.js already does:
     *
     * Add product
     * ↓
     * updateCart()
     * ↓
     * refreshCartDrawer()
     *
     * We replace ONLY refreshCartDrawer().
     */

    window.ajaxCollection
      .refreshCartDrawer =
      function () {

        return refresh(
          true
        );

      };


    /*
     * Replace the old drawer opener.
     */

    window.ajaxCollection
      .openCartDrawer =
      function () {

        openMiniCart();

      };


    /*
     * Disable the old quantity
     * binding for our drawer.
     */

    window.ajaxCollection
      .bindCartDrawerEvents =
      function () {

        removeOldHandlers();

      };


    removeOldHandlers();


    bindQuantityEvents();


    /*
     * Render current cart.
     */

    refresh(
      false
    );


    return true;

  }


  /* ==========================================================
     WAIT FOR CUSTOM COLLECTION JS
     ========================================================== */

  document.addEventListener(
    "DOMContentLoaded",
    function () {

      var tries = 0;


      var timer =
        setInterval(
          function () {

            tries++;


            if (
              install() ||
              tries >= 40
            ) {

              clearInterval(
                timer
              );

            }

          },
          100
        );

    }
  );

})();